import { render, staticRenderFns } from "./ProductFormDialog.vue?vue&type=template&id=4520a302"
import script from "./ProductFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFormDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports